import { render, staticRenderFns } from "./DeleteConfirmationModal.vue?vue&type=template&id=64b279eb&scoped=true"
import script from "./DeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteConfirmationModal.vue?vue&type=style&index=0&id=64b279eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b279eb",
  null
  
)

export default component.exports